const swiperartikkelikaruselli = new Swiper('.artikkelikaruselli-container__keski.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    autoHeight: false,
/*     autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    }, */


    // If we need pagination
    pagination: {
      el: '.swiper-pagination-artikkelikaruselli',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next-artikkelikaruselli',
        prevEl: '.swiper-button-prev-artikkelikaruselli',
    },

    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1,
            spaceBetween: 16,
        },
        // when window width is >= 480px
        420: {
            slidesPerView: 1,
            spaceBetween: 24,
        },

        // when window width is >= 550px
        550: {
            slidesPerView: 1,
            spaceBetween: 24,
        },

        // when window width is >= 640px
        640: {
            slidesPerView: 1,
            spaceBetween: 24,
        },

        720: {
            slidesPerView: 2,
            spaceBetween: 24,
        },

        1120: {
            slidesPerView: 3,
            spaceBetween: 32,
        },

        1250: {
            slidesPerView: 3,
            spaceBetween: 32,
        },

        1480: {
            slidesPerView: 3,
            spaceBetween: 32,
        }
    },

/*     // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    }, */
  });
